export default __webpack_public_path__ + "static/media/UserGreyIcon.4b64c1fa.svg";